import { useEffect } from 'react';
import { ORDER_SITE_URL } from '@/lib/externalLinks';

const ExternalOrderRedirect = () => {
  useEffect(() => {
    window.location.replace(ORDER_SITE_URL);
  }, []);

  return (
    <div className="flex min-h-screen items-center justify-center bg-white px-4 text-center">
      <div>
        <p className="text-lg font-semibold text-gray-900">Taking you to Dough Man ordering...</p>
        <a
          href={ORDER_SITE_URL}
          className="mt-3 inline-block text-amber-700 underline underline-offset-4"
        >
          Continue to order.doughmanfoods.com
        </a>
      </div>
    </div>
  );
};

export default ExternalOrderRedirect;
